import { useCallback } from 'react';
import { ToastNotification } from '../components/Notifications/NotificationToast';

export function useNotifications() {
  const showNotification = useCallback((notification: Omit<ToastNotification, 'id'>) => {
    if (typeof window !== 'undefined' && (window as any).showNotification) {
      (window as any).showNotification(notification);
    }
  }, []);

  const showSuccess = useCallback((title: string, message: string) => {
    showNotification({
      title,
      message,
      type: 'success',
      duration: 4000,
    });
  }, [showNotification]);

  const showError = useCallback((title: string, message: string) => {
    showNotification({
      title,
      message,
      type: 'error',
      duration: 6000,
    });
  }, [showNotification]);

  const showInfo = useCallback((title: string, message: string) => {
    showNotification({
      title,
      message,
      type: 'info',
      duration: 5000,
    });
  }, [showNotification]);

  const showWarning = useCallback((title: string, message: string) => {
    showNotification({
      title,
      message,
      type: 'warning',
      duration: 5000,
    });
  }, [showNotification]);

  return {
    showNotification,
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
}